
<template>
  <div class="container pagebreak default_font">
    <br />
    <br />

    <div>
      <div class="row">
        <div class="col-xs-12 text-left" style="margin-top:30px;">
          <div v-if="projectLogo" class="text-right" style="float: left !important;">
            <img :src="projectLogo" class="resize-project-logo-lg" />
          </div>
          <div style="float: left; font-size: 12px; font-family: Times New Roman, Times, serif;">
            <span>{{ receipt_data.operator_name }}</span>
            <br /><span>{{ receipt_data.operator_address }}</span>
            <br />MST: {{ receipt_data.tax_identification_number }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="text-center"
      style="background-color:#168AD6;font-size: 20px; font-family: Times New Roman, Times, serif; 
      font-weight: bold; text-transform: uppercase;margin-top:15px;color:white;"
    >PHIẾU THU</div>
    <div
      class="text-center"
      style="font-size: 16px; font-family: Times New Roman, Times, serif; text-transform: uppercase;"
    >
      <i>Receipt</i>
    </div>
    <div style="margin-top:20px;">
      <div
        class="text-center"
        style="font-size: 12px; font-family: Times New Roman, Times, serif;border:1px solid white;float:left;text-align:right;width:61%;"
      ></div>
      <div
        class="text-center"
        style="font-size: 12px; font-family: Times New Roman, Times, serif; loat:left;border:1px solid white;text-align:left;"
      >
        <b style="margin-left:50px;">Số</b> /
        <i>No</i>:
        <b>{{receipt_data.receipt_code}}</b>
      </div>
    </div>

    <div>
      <div
        class="text-center"
        style="font-size: 12px; font-family: Times New Roman, Times, serif;float:left;text-align:right;width:61%;"
      >Ngày/ date {{receipt_data.current_day}} tháng/ month {{receipt_data.current_month}} năm/ year {{receipt_data.current_year}}</div>
      <div
        class="text-center"
        style="font-size: 12px; font-family: Times New Roman, Times, serif; loat:left;text-align:left;"
      >
        <b style="margin-left:50px;"></b>
        <i></i>
        <b></b>
      </div>
    </div>

    <div class="container" style="margin-top:30px;">
      <div class="row">
        <table
          class="table table-condensed"
          style="width:80%; border:0px solid red; margin-left : 10%"
        >
          <tbody>
            <tr>
              <td style="width:20%">
                <b>Ngày</b> /
                <i>Date</i>:
              </td>
              <td style="width:60%">
                <b class="text-uppercase" style="text-align:left;">{{receipt_data.date_created}}</b>
              </td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Họ và tên người nộp tiền:</b>
                <br />
                <i>Name of Payment Applicant</i>:
              </td>
              <td style="width:60%; text-transform: uppercase;">{{receipt_data.resident_fullname}}</td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Địa chỉ:</b>
                <br />
                <i>Address</i>:
              </td>
              <td style="width:60%">{{receipt_data.resident_address}}</td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Số tiền</b>
                <br />
                <i>Amount</i>:
              </td>
              <td style="width:60%">{{receipt_data.expected_amount_show}} (VNĐ)</td>
            </tr>
            <tr>
              <td style="width:20%">
                <b>Bằng chữ</b>
                <br />
                <i>Total in Words</i>:
              </td>
              <td style="width:60%">
                <b>{{readMoney(receipt_data.expected_amount, "vi")}} ./.</b>
                <br />
                <i>({{readMoney(receipt_data.expected_amount, "en")}} ./.)</i>
              </td>
            </tr>
            <tr v-show="!ishow">
              <td style="width:20%">
                <b>Nội dung</b>
                <br />
                <i>Description</i>:
              </td>
              <td style="width:60%">
                <b style="color:red">{{receipt_data.explaination}}</b>
              </td>
            </tr>
            <tr v-show="ishow">
              <td style="width:20%">
                <b>Nội dung:</b>
                <br />
                <i>Description</i>:
              </td>
              <td style="width:60%">
                <b>Số tiền {{formatNumber(receipt_data.amount)}} VNĐ.
                  {{ !isEmptyString(receipt_data.rest_of_amount) ? ((!is_debt ? 'Số dư ' : 'Dư nợ ') + (formatNumber(receipt_data.rest_of_amount))) + "VNĐ." : '' }} </b>
                <br />
                <i>(Amount: {{readMoney(receipt_data.amount, "en")}}. Excess: {{readMoney(receipt_data.rest_of_amount, "en")}} ./.)</i>
              </td>
            </tr>
            <!-- <tr>
                            <td style="width:20%">Người Tạo (User created): </td>
                            <td style="width:40%"><b class="text-uppercase" style="text-align:left;">{{receipt_data.user_created_full_name}}</b></td>
            </tr>-->
          </tbody>
        </table>
        <div>
          <div
            class="text-center"
            style="font-size: 12px; font-family: Times New Roman, Times, serif;float:right;text-align:right;margin-right:1%;margin-bottom:10px;"
          >Ngày/ date {{receipt_data.current_day}} tháng/ month {{receipt_data.current_month}} năm/ year {{receipt_data.current_year}}</div>
        </div>
      </div>

      <div class="row">
        <table class="table table-condensed" style="border:0px; margin-left:5% ">
          <tr>
            <th class="text-center">
              <b>Người lập phiếu</b>
              <br />
              <i class="table_column_en">Drafted by</i>
            </th>
            <th class="text-center">
              Người nộp tiền
              <br />
              <i class="table_column_en">Payment Applicant</i>
            </th>
            <th class="text-center">
              Thủ quỹ
              <br />
              <i class="table_column_en">Cashier</i>
            </th>
            <th class="text-center">
              Kế toán trưởng
              <br />
              <i class="table_column_en">Chief Accountant</i>
            </th>
            <th class="text-center">
              Thủ trưởng đơn vị
              <br />
              <i class="table_column_en">Director</i>
            </th>
          </tr>

          <br />
          <br />
          <br />

          <tr>
            <th class="text-center">{{receipt_data.user_created_full_name}}</th>
            <th class="text-center"></th>
            <th class="text-center"></th>
            <th class="text-center"></th>
          </tr>
        </table>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
// import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";

import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

// https://vue-multiselect.js.org/
import "vue-multiselect/dist/vue-multiselect.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import Multiselect from "vue-multiselect";
// import LTEModal from "@/components/LTEModal.vue";
import utils from "@/lib/utils";
import i18n from "../../lang";

export default {
  props: ["item"],
  name: "ComponentReceiptPdf_TM",
  data() {
    return {
      projectLogo: null,
      ishow: false,
      receipt_data: {
        id: 0,
        receipt_code: "",
        expected_amount: 0,
        expected_amount_show: 0,
        actual_amount: 0,
        user_created: "",
        user_created_full_name: "",
        date_created: new Date(),
        excess_cash: 0,
        payments_type: 1,
        invoice_id: 0,
        monthy_services: [],
        receipt_monthy_services_name: "",
        resident_fullname: "",
        resident_address: "",
        apartment_code: "",
        month: "",
        record_date: "",
        explaination: "",
        amount: 0,
        rest_of_amount: 0,
        current_day: null,
        current_month: null,
        current_year: null,
        operator_name: "",
        operator_address: "",
        tax_identification_number: ""
      },
      is_debt: false
    };
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_RECEIPT_EXPLAINATION_BY_RECEIPT_ID"
    ]),
    isEmptyString: function(value) {
      return utils.isEmptyString(value)
    },
    formatNumber: function(amount) {
      return utils.formatNumber(amount);
    },
    readMoney: function(number, locale) {
      return utils.readMoney(number, locale);
    },
    CancelInvoiceList: function() {
      this.$router.push({
        name: "ReceiptList"
      });
    },

    printInvoice: function() {
      document.getElementById("cmdCancel").style.display = "none";
      document.getElementById("cmdPrintPdf").style.display = "none";
      window.print();
      document.getElementById("cmdCancel").style.display = "";
      document.getElementById("cmdPrintPdf").style.display = "";
    },

    convertDateVN(date) {
      // Day
      let day = utils.formatSqlDate(date, null, "DD");
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");
      return "Ngày " + day + " tháng " + month + " năm " + year;
    },
    convertDateMonth(date) {
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");
      return " tháng " + month + " năm " + year;
    },
    convertDateEN(date) {
      return utils.formatSqlDate(date, null, "DD MMM YYYY");
    },

    formatTotalFee(total_fee, isFormat = false) {
      if (total_fee != undefined) {
        total_fee = utils.makeRoundNumber(total_fee);
        let rs = total_fee.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return rs == 0 && isFormat ? "-" : rs;
      }
    }
  },
  async mounted() {
    let amount = 0;
    let current_date = new Date();
    this.projectLogo = sessionStorage.getItem('projectLogo')
    this.receipt_data.current_day = current_date.getDate();
    this.receipt_data.current_month = current_date.getMonth() + 1;
    this.receipt_data.current_year = current_date.getFullYear();
    this.receipt_data.id = this.item.id;
    this.receipt_data.receipt_code = this.item.receipt_code;
    this.receipt_data.expected_amount = this.item.amount;
    this.receipt_data.expected_amount_show = this.formatTotalFee(
      this.item.amount
    );
    if (parseInt(this.receipt_data.id) !== 0) {
      await this.GET_RECEIPT_EXPLAINATION_BY_RECEIPT_ID({
        id: this.receipt_data.id
      }).then(
        function(res) {
          amount = res;
        }.bind(this)
      );
    }

    // this.receipt_data.amount = amount;
    this.receipt_data.amount = this.item.amount
    this.receipt_data.expected_amount_show = this.formatTotalFee(
      amount > this.receipt_data.expected_amount
        ? amount
        : this.receipt_data.expected_amount
    );
    let balance = !utils.isNull(this.item.balance) ? this.item.balance : 0
    // số dư nhập từ file excel 
    // nên: âm dư tiền , dương là nợ tiền
    if (balance > 0) {
      this.is_debt = true
    } else {
      this.is_debt = false
    }
    this.ishow = true
    this.receipt_data.rest_of_amount = Math.abs(balance)
    this.receipt_data.actual_amount = this.formatTotalFee(
      this.item.actual_amount
    );
    this.receipt_data.excess_cash = this.formatTotalFee(
      this.item.actual_amount - this.item.expected_amount
    );

    this.receipt_data.user_created = this.item.user_created;
    this.receipt_data.user_created_full_name = utils.getFullName(
      this.item.user_first_name,
      this.item.user_last_name,
      i18n.locale
    );
    this.receipt_data.resident_fullname = utils.isNull(this.item.payer)
      ? this.item.apartment.owner_apartment
      : this.item.payer;
    this.receipt_data.resident_address = this.item.apartment.owner_address
    this.receipt_data.date_created = utils.formatSqlDate(this.item.date_created, null, "DD/MM/YYYY");

    this.receipt_data.payments_type = this.item.receipt_type;
    //this.receipt_data.receipt_monthy_services_name = this.item.receipt_monthy_services_name.name;
    this.receipt_data.invoice_id = this.item.invoice;
    this.receipt_data.apartment_code = this.item.apartment.apartment_code;
    this.receipt_data.month = utils.formatSqlDate(this.item.date_created, null, "MM");
    this.receipt_data.explaination = this.item.explaination;
    this.receipt_data.record_date = utils.formatSqlDate(this.item.due_date, null, "DD/MM/YYYY");
    this.receipt_data.operator_name = !utils.isNull(
      this.item.project_data.operator_name
    )
      ? this.item.project_data.operator_name
      : "";
    this.receipt_data.operator_address = !utils.isNull(
      this.item.project_data.operator_address
    )
      ? this.item.project_data.operator_address
      : "";
    this.receipt_data.tax_identification_number = !utils.isNull(
      this.item.project_data.tax_identification_number
    )
      ? this.item.project_data.tax_identification_number
      : "";
  },
  components: {
    // Multiselect,
    // "lte-modal": LTEModal
  }
};
</script>

<style scoped>
.btn-label {
  position: relative;
  left: -12px;
  display: inline-block;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px 0 0 3px;
}

.btn-labeled {
  padding-top: 0;
  padding-bottom: 0;
}

.btn {
  margin-bottom: 10px;
}

.table_total_fee {
  border: 1px solid #000000 !important;
}

.table_total_fee thead tr,
.table_total_fee thead tr th,
.table_total_fee td,
.table_total_fee th {
  border: 1px solid #000000 !important;
}

.container {
  font-family: Times New Roman, Times, serif !important;
}

body {
  font-size: 12px !important;
}
.resize-project-logo-lg {
  height: auto;
  width: auto;
  max-width: 80px;
  max-height: 60px;
}
@media print {
  .pagebreak {
    clear: both;
    page-break-after: always;
  }
}
/* remove title when print */
@page {
  size: auto;
  margin: 0mm;
}

.table_column_en {
  font-style: italic;
  font-weight: 100;
}

table {
  border: 1px solid #ccc;
  border-collapse: collapse;
}

td {
  border-top: 0px solid !important;
}
</style>




// WEBPACK FOOTER //
// src/views/Receipt/ComponentReceiptPdf_TMV2.vue